import type { ExplorationAccountCache, ExplorationVolume } from '../types/exploration';

export function findVolumeByEbsId(
  accounts: Record<string, ExplorationAccountCache>,
  accountId: string | null,
  ebsId: string
): ExplorationVolume | undefined {
  const volumes = accountId ? accounts[accountId]?.volumes ?? [] : [];
  return volumes.find((v) => v.ebsId === ebsId);
}
